<template>
  <div class="warp">
 
    <div class="title">CAC2024参展商邀请函申请</div>
   

    <div class="item">
      <div class="smallTitle">一、邀请函办理时间</div>
      <div class="text">12月1日 --- 2月1日（2月10-16日春节假期）</div>
    </div>

    <div class="item">
      <div class="smallTitle">二、邀请停留时间（不可更改）：</div>
      <div class="text">限CAC2024农化展会期间，一般展会前后各延两天。</div>  
    </div>
   
    <div class="item">
      <div class="smallTitle">三、参展商提交材料</div>
      <div class="text">1.申请人签证邀请函模版（填写附件1-word模板并回传）</div>
      <div class="text">2.申请人信息表（填写附件2-excel模板并回传）</div>
      <div class="text">3.申请人护照首页扫描件（离展期结束不少于6个月，即有效期2024年9月15日以后）</div>
    </div>

    <div class="textInter">特别提示: 从今年12月1日起到明年11月30日，法国、德国、意大利、荷兰、西班牙和马来西亚的公民来华进行短期入境或过境，可享受免签待遇，停留时间不超过15天。</div>
    <!-- <div class="time">2023年11月</div> -->
    <div style="margin-top:10px">
      <el-button type="primary"  ><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">附件1：申请人签证邀请函模板.doc</a></el-button>
      <el-button type="primary"  ><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">附件2：申请人信息表.xls</a></el-button>
    </div>

  </div>
</template>
<script>


export default {
  data(){
      return{
        file1:'./附件1：申请人签证邀请函模板.doc',
        file2:'./附件2：申请人信息表.xls'
      }
  },
  components: {},
  mounted() {
   
  },
  methods: {
  


  }
}
</script>
<style lang="less">

.warp{
  max-width: 80%;
  padding-left: 5% !important;
}
.title{
  font-size: 28px;
  text-align: center;
  padding:30px 0;
  font-weight: bold;
}
.item{
  padding-bottom: 14px;
}
.item .smallTitle{
  font-weight: bold;
  padding:6px 0;
  font-size: 18px;
}
.item .text{
  font-size: 16px;
  line-height: 28px;
}
.textInter{
  font-size: 16px;
  line-height: 28px;
}
.time{
  font-size: 16px;
  text-align: right;
  padding-top: 10px;
}
</style>

